module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/clutter_c-cb08dcf62cdcbe5a310a1be8b9a49fe0.svg";